import { Appearance, StyleSheet } from 'react-native';


export enum WhiteColor {
  textColor = '#4C4D4F',
  linkColor = '#BB8760',
  focusColor = '#0E85D9',
  whiteColor = '#FFFFFF',
  grayColor = '#C4C5CE',
  mainColor = '#DC222A',
  mainColorSpace = '#DC222A',
  bordercolor = '#EFE8DF',
  disableColor = '#E9EAEF',
  greenColor = '#16C79A',
  redColor = '#ED1C24',
  growColor = '#00BC08',
  yellowColor = '#FEE005',
  spaceColor = '#F0F0F0',
  blue = '#007bff',
  red = 'red',
  bgtime = '#F0F0F0',
  bordercolorBox = '#F0F0F0',
  gray = 'gray',
  gray2x = 'rgba(0,0,0,0.3)',
  gray3x = '#e0e0e0',
  green = '#3cbc98',
  black = '#000000',
  white = '#ffffff',
  placeHoderColor = '#888888',
  transparentLoading = 'rgba(0,0,0,0.2)',
  transparent = 'transparent',
}

export const Ecolors =
  Appearance.getColorScheme() === 'dark' ? WhiteColor : WhiteColor;

export enum Efonts {
  bold = 'Roboto-Bold',
  medium = 'Roboto',
  italic = 'Roboto-Italic',
}

export const EStyle = StyleSheet.create({
  shadow: {
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.32,
    shadowRadius: 5.46,
    elevation: 9,
  },
  shadowItem: {
    // shadowColor: '#000',
    // shadowOffset: {
    //   width: 0,
    //   height: 1,
    // },
    // shadowOpacity: 0.2,
    // shadowRadius: 1.41,
    // elevation: 2,
  },
});
